//react
import React from "react";

//scss
import "./AccessModal.scss"
import ic_close from "../../Resources/Images/ic_close.png";
import CommonUtils from "../../Utils/CommonUtils";
import { COLORLIST } from "../../Constants";

export const AccessModal = ({ handleClose, show, parent, children }) => {
	const showHideClassName = show ? "modal display-block" : "modal display-none";

    let connectionsList = []

    if(children && children.length !==0) {
        children[0].upgraded_connections.forEach((item)=>{
            // console.log(item)
            let mappingObj = {
                monitoring_user_first_name: item.mapping.monitoring_users.first_name,
                monitoring_user_last_name: item.mapping.monitoring_users.last_name,
                monitored_user_relation: item.mapping.monitoring_user_relation,
                monitored_user_first_name: item.mapping.monitored_users && item.mapping.monitored_users.first_name,
                monitored_user_last_name: item.mapping.monitored_users && item.mapping.monitored_users.last_name
            }
            connectionsList.push(mappingObj);
        })
    }

	return (
		<div className={showHideClassName}>
			<section className="mainModal">
				
                <div className="modalHeaderContainer">
                    <div className="headerLabel">
                        <h6>Access</h6>
                        <hr></hr>
                    </div>
                    <div className="closeBtn" onClick={handleClose}>
                        <img src={ic_close} alt={"ic_close"}></img>
                    </div>
                </div>

                <div className="accessCountContainer">
                    <h6 className="accessCount">{(connectionsList && connectionsList.length)} Access</h6>
                </div>

                <div className="listContainer">
                    {
                        connectionsList && connectionsList.map((mapping,index) => {
                            return (
                            <div key={index} style={{backgroundColor: CommonUtils.getColorByIndex(index,COLORLIST)}}  className="mappingInfoContainer">
                                <div className="profileImg">
                                    <div className="initials">
                                        <label>
                                        {mapping.monitored_user_first_name && mapping.monitored_user_first_name[0].toUpperCase()}
                                        {mapping.monitored_user_last_name && mapping.monitored_user_last_name[0].toUpperCase()}
                                        </label>
                                    </div>
                                </div>
                                
                                <div className="mappingInfo">
                                    <div className="monitoredUserName">{mapping.monitored_user_first_name} {mapping.monitored_user_last_name}</div>
                                    <div className="monitoredUserRelation">{mapping.monitored_user_relation}</div>  
                                    <div className="monitoringUser">
                                        <span>by </span> 
                                        <span className="monitoringUserName">{mapping.monitoring_user_first_name} {mapping.monitoring_user_last_name}</span>
                                    </div>
                                    
                                </div>
                            </div>
                            )
                        })
                    }
                </div>
			</section>
            
		</div>
	);
};
